import { useMemo } from 'react';
import { intl } from './intl'

export type SettingsTranslation = ReturnType<typeof useTranslations>

export const useTranslations = () => {
  const { formatMessage, locale } = intl();

  return useMemo(() => ({
    alternatePayeeForm: {
      editButton: formatMessage({ id: "general.button.edit", defaultMessage: "EDIT" }),
      viewButton: formatMessage({ id: "general.button.view", defaultMessage: "VIEW" }),
      saveButton: formatMessage({ id: "general.button.save", defaultMessage: "SAVE" }),
      cancelButton: formatMessage({ id: "general.button.cancel", defaultMessage: "CANCEL" }),
      alternatePayeeNameLabel: formatMessage({ id: "alternatePayeeForm.field.alternatePayeeName", defaultMessage: "Alternate Payee Name" }),
      bankCountryLabel: formatMessage({ id: "alternatePayeeForm.field.bankCountry", defaultMessage: "Bank Country" }),
      desiredPayoutCurrencyLabel: formatMessage({ id: "alternatePayeeForm.field.desiredPayoutCurrency", defaultMessage: "Desired Payout Currency" }),
      accountTypeLabel: formatMessage({ id: "alternatePayeeForm.field.accountType", defaultMessage: "Account Type" }),
      routingNumberLabel: formatMessage({ id: "alternatePayeeForm.field.routingNumber", defaultMessage: "Routing Number (Swift/Bic)" }),
      currentRoutingNumberLabel: formatMessage({ id: "alternatePayeeForm.field.current.routingNumber", defaultMessage: "Current Routing Number: " }),
      accountNumberLabel: formatMessage({ id: "alternatePayeeForm.field.accountNumber", defaultMessage: "Account Number (IBAN)" }),
      currentAccountNumberLabel: formatMessage({ id: "alternatePayeeForm.field.current.accountNumber", defaultMessage: "Current Account Number: " }),
      accountHolderNameLabel: formatMessage({ id: "alternatePayeeForm.field.accountHolderName", defaultMessage: "Account Holder's Name" }),
      bankNameLabel: formatMessage({ id: "alternatePayeeForm.field.bankName", defaultMessage: "Bank Name" }),
      lastModifiedDateLabel: formatMessage({ id: "alternatePayeeForm.notification.lastModifiedDate", defaultMessage: "Last Modified Date: " }),
      helperLabel: formatMessage({ id: "alternatePayeeForm.notification.lastModifiedDate.helper", defaultMessage: "Refreshes on save" }),
      //errors
      errorMaxLength: formatMessage({ id: "alternatePayeeForm.error.maxLength", defaultMessage: "Maximum length exceeded" }),
      errorRoutingNumber: formatMessage({ id: "alternatePayeeForm.error.routingNumber", defaultMessage: "Routing number not formatted correctly" }),
    },
    summaryPage: {
      viewButton: formatMessage({ id: "general.button.view", defaultMessage: "VIEW" })
    },
    addNewPayeeButton: {
      add: formatMessage({ id: "general.button.addNewPayee", defaultMessage: "ADD NEW PAYEE" })
    }
  }), [locale])
};
